module.exports = __webpack_public_path__ + "img/logo-sheetlabels-popup.1ccd3f78.svg";